/*global DM, $*/

function preRender(tabSlugs)
{
        const   selectedClass = 'react-tabs__tab--selected',
                tabsClass     = 'react-tabs__tab',
                url           = window.location.href;

        var     initTabIdx    = 0;

        // find which of the tab slugs is currently selected
        tabSlugs.forEach((slug, idx) => {
                if (url.indexOf(slug) > -1) {
                        initTabIdx = idx;
                }
        });

        // reset selection
        $(`li.${tabsClass}`).removeClass(selectedClass).attr('aria-selected', false);

        // apply selection as obtained from the url
        $(`li.${tabsClass}:nth-child(${initTabIdx+1})`).addClass(selectedClass).attr('aria-selected', true);
}


window.build = function(modules, complete)
{
        // restore the page state to effectively pre-render the react state
        preRender(['markers','boundaries','choropleth','geobarcharts']);

        // signal the build is complete enough to remove any dm-hide-until-bootcomplete classes
        complete();

        // now load the rest of the stack to inflate the UI into useable react components
        DM.loadModules('hm-www','google-mapsapi','embed-dependencies').then(modules => {

                // build the page
                var page = modules['hm-www'].default({
                        tabContentId: 'dm-tab-markup',
                        content:      'mapping-101'
                });

                // load the map modules and boot
                page.bootMap();
        });

};



// WEBPACK FOOTER //
// ./assets/js/learn.js